import { IPromise } from "angular";
import { ProcessInstancesNotesView } from "../../../../../model/ProcessApi";
import {
  CreateInterval,
  DetailTimelineDataItem,
  TimelineItemSource,
} from "../../sources";
import {
  ProcessTimelineArgs,
  ProcessTimelineGroup,
} from "../stateInterval/source";
import { ServerUtility } from "../../../../../../records/server/serverUtility";
import { getComponentName } from "../detailComponent";

export const vsComponentName = getComponentName("notes");

export class ProcessNoteTimelineSource extends TimelineItemSource<
  ProcessTimelineGroup,
  ProcessTimelineArgs,
  ProcessInstancesNotesView,
  DetailTimelineDataItem<ProcessInstancesNotesView>
> {
  constructor(private readonly serverUtility: ServerUtility) {
    super();
  }

  protected override createTimelineDataItem(
    args: CreateInterval<ProcessInstancesNotesView>,
  ): DetailTimelineDataItem<ProcessInstancesNotesView> {
    return {
      ...super.defaultTimelineItem<ProcessInstancesNotesView>(args),
      component: vsComponentName,
      type: "point",
      bubbleNestedEventUp: true,
    };
  }

  getSourceItems(
    args: ProcessTimelineArgs,
  ): IPromise<DetailTimelineDataItem<ProcessInstancesNotesView>[]> {
    const processId = args.process.Id;
    return this.serverUtility
      .fetchAll<ProcessInstancesNotesView>({
        url: `api/processes/instances/${processId}/notes`,
        query: {},
      })
      .then((notes) =>
        notes.map((n) =>
          this.createTimelineDataItem({
            content: `Note by ${n.UserAuthFirstName} ${n.UserAuthLastName}`,
            data: n,
            group: n.StateId,
            start: n.CreatedDate,
          }),
        ),
      )
      .then((items) => {
        this.styleItems(items, args.groups);
        return items;
      });
  }
}
